/*
 * @Author: guoyu
 * @Date: 2021-04-12 17:19:24
 * @LastEditors: your name
 * @LastEditTime: 2021-04-12 19:59:22
 * @Description: app调用H5方法
 */

const NATIVE_CALL_METHODS = {};
window._nativeCall = _nativeCall

/**
 * @description: app调用H5方法的统一入口
 * @param {*} options type: 要执行的方法名 data: 执行参数
 * @return {*}
 */
function _nativeCall(options = {}) {
  if (typeof options === 'string') {
    try {
      options = JSON.parse(options)
    } catch (e) {
      console.error('执行参数无法解析', e)
    }
  }
  const { type: methodName, data } = options;
  const handle = getCallFn(methodName)
  if (typeof handle === 'function') {
    handle(data)
  }
}

/**
 * @description: 获取要执行的方法
 * @param {*} methodName
 * @return {*}
 */
export function getCallFn(methodName) {
  const callFns = NATIVE_CALL_METHODS[methodName];
  if (!callFns) {
    console.error(methodName, '不存在');
    return;
  }
  const { fn, args = [], once } = callFns;
  return function handle(data) {
    const callArgs = [data, ...args];
    fn(...callArgs);
    if (once) {
      delete NATIVE_CALL_METHODS[methodName];
    }
  };
}

/**
 * @description: 设置要执行的方法
 * @param {*} methodName
 * @param {*} options fn: 执行的函数体 once: 是否只执行一次 args: 固定的参数
 * @return {*}
 */
export function setCallFn(methodName, options = {}) {
  if (typeof options === 'function') {
    options = {
      fn: options
    };
  }
  if (NATIVE_CALL_METHODS[methodName]) {
    console.warn(methodName, '已经存在,当前操作将更新覆盖');
  }

  if (!options.fn) return;

  NATIVE_CALL_METHODS[methodName] = options;
}
